import { Controller } from "@hotwired/stimulus"

// A list of fields you can add to and take from before saving. The numbers are
// drawn again after every change, so the list always reads in order.
export default class extends Controller {
  static targets = ["list", "row", "template", "destroy", "position"]

  add(event) {
    event.preventDefault()
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    this.renumber()
    this.rowTargets[this.rowTargets.length - 1]?.querySelector("input[type=text], textarea")?.focus()
  }

  // A row that has been saved has to come back saying it is going, or the record
  // never hears about it. One that was only ever typed here can just leave.
  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest(`[data-${this.identifier}-target='row']`)
    const destroy = row.querySelector(`[data-${this.identifier}-target='destroy']`)

    if (destroy && row.querySelector("input[name$='[id]']")?.value) {
      destroy.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
    this.renumber()
  }

  renumber() {
    this.rowTargets.filter((row) => !row.hidden).forEach((row, index) => {
      const number = row.querySelector("[data-number]")
      if (number) number.textContent = index + 1

      const position = row.querySelector(`[data-${this.identifier}-target='position']`)
      if (position) position.value = index + 1
    })
  }
}
